export function setupIsScrolledDetector() {

  let isScrolled = false;
  const scrollThreshold = window.innerHeight / 100 * 1;

  const handleScroll = () => {
    if (!isScrolled && window.scrollY > scrollThreshold) {
      document.body.classList.add("-is-scrolled");
      isScrolled = true;
    } else if (isScrolled && window.scrollY <= scrollThreshold) {
      document.body.classList.remove("-is-scrolled");
      isScrolled = false;
    }
  };

  window.addEventListener('scroll', handleScroll)
}